
import { Component, Prop, Vue } from 'vue-property-decorator'
import RobotMsgTmpl from '@/components/robot-msg-tmpl.vue'
import AnswerItem from '@/components/answer-item.vue'

@Component({
  components: {
    RobotMsgTmpl,
    AnswerItem
  }
})
export default class TopAsk extends Vue {
  @Prop()
  private hotList!: Array<string>

  @Prop({ type: String, default: '' })
  robotImg!: string

  // 显示的最大条数
  readonly maxNum = window.config.maxNum

  private pageNum = 1

  get dataList () {
    const length = this.hotList.length
    if (length < this.maxNum) {
      return [...this.hotList]
    }

    const array = []
    const first = this.pageNum * this.maxNum - this.maxNum
    const last = this.pageNum * this.maxNum
    for (let i = first, j = last; i < j; i++) {
      array.push(this.hotList[i % length])
    }
    return array
  }

  refreshData () {
    this.pageNum = this.pageNum + 1
  }

  onClick (text: string) {
    this.$emit('select', text)
  }
}
